import React from 'react'

export default function MorningstarOptions({
  selectedDisplayMorningstarGroup,
  onChangeDisplayMorningstarGroup,
}) {
  const onChangeDisplayMorningstarGroupCheckbox = (event) => {
    onChangeDisplayMorningstarGroup(event)
  }

  return (
    <>
      <div className="Checkbox u-marginLeft2gu">
        <input
          type="checkbox"
          id={'morningstarGroupCheckbox'}
          className="Checkbox-button"
          checked={selectedDisplayMorningstarGroup}
          onChange={onChangeDisplayMorningstarGroupCheckbox}
        ></input>
        <label htmlFor={'morningstarGroupCheckbox'} className="Checkbox-label">
          <div className="u-textNoWrap">Group by Morningstar Category</div>
        </label>
      </div>
    </>
  )
}
